module.exports = __webpack_public_path__ + "static/media/Profile Picture3@4x.0e924bdf.png";